/** Shared chrome for Header + Sidebar — EduOKGold colorPrimary #F9A602 */
export const NAV_CHROME = {
  deep: '#CA8702',
  mid: '#DE9502',
  bright: '#F9A602',
  light: '#F9A602',
  headerGradient: 'linear-gradient(120deg, #A26C02 0%, #CA8702 48%, #DE9502 100%)',
  sidebarGradient: 'linear-gradient(180deg, #CA8702 0%, #DE9502 42%, #A26C02 100%)',
  border: 'rgba(25, 25, 25, 0.12)',
  borderSoft: 'rgba(25, 25, 25, 0.08)',
  glass: 'rgba(255, 255, 255, 0.38)',
  glassHover: 'rgba(255, 255, 255, 0.55)',
  glassBorder: 'rgba(25, 25, 25, 0.14)',
  text: '#191919',
  textMuted: 'rgba(25, 25, 25, 0.68)',
  // Side nav — dark labels on gold chrome
  sidebarText: '#191919',
  sidebarTextMuted: 'rgba(25, 25, 25, 0.72)',
  sidebarLabel: 'rgba(25, 25, 25, 0.78)',
  // Active accent — EduOKGold highlight_color1
  yellow: '#E74900',
  yellowDeep: '#151515',
  yellowSoft: 'rgba(231, 73, 0, 0.16)',
  yellowSofter: 'rgba(255, 255, 255, 0.62)',
  yellowBorder: 'rgba(231, 73, 0, 0.5)',
  label: '#6B4701',
  ink: '#ffffff',
  shadow: '0 8px 24px rgba(162, 108, 2, 0.28)',
  drawerWidth: 248,
  headerHeight: 72,
  /** Cycling icon colors from EduOKGold card palette */
  iconColors: ['#E74900', '#0C7300', '#0765D6', '#CD014D', '#7E57C2', '#02BBA1', '#702B56'],
}
